import React, {Fragment} from 'react';

import withClass from '../../../../hoc/withClass';
import Button from '../../../UI/Button/Button';
import Icon from '../../../UI/Icon/Icon';
import CompanyLogo from '../../../Logo/CompanyLogo/CompanyLogo';

const navbarHeader = () => (
    <Fragment>
        <Button buttonType="button" buttonClass="navbar-toggler hamburger hamburger-close navbar-toggler-left hided" buttonToggle="menubar">
            <span className="sr-only">Toggle navigation</span>
            <span className="hamburger-bar"></span>
        </Button>
        <Button buttonType="button" buttonClass="navbar-toggler collapsed" buttonTarget={document.querySelector('#site-navbar-collapse')} buttonToggle="collapse">
            <Icon iconClass="icon md-more" />
        </Button>
        <div data-toggle="gridmenu">
          <CompanyLogo />
        </div>
        <Button buttonType="button" buttonClass="navbar-toggler collapsed" buttonTarget={document.querySelector('#site-navbar-search')} buttonToggle="collapse">
            <span className="sr-only">Toggle Search</span>
            <Icon iconClass="icon md-search" />
        </Button>
        
    </Fragment>
);

export default withClass(navbarHeader, 'navbar-header');